// Import necessary Angular modules
import {
  Directive,
  HostListener,
  HostBinding,
  EventEmitter,
  Output,
} from '@angular/core'

@Directive({
  selector: '[appDragAndDrop]',
  standalone: false,
})
export class DragAndDropDirective {
  @Output() fileDropped: EventEmitter<FileList> = new EventEmitter<FileList>()
  // Use HostBinding to dynamically set the class when dragging over
  @HostBinding('class.drag-over') protected isDraggingOver = false

  // Listen for the dragover event
  @HostListener('dragover', ['$event']) onDragOver(event: Event) {
    event.preventDefault()
    event.stopPropagation()
    this.isDraggingOver = true
  }

  // Listen for the dragleave event
  @HostListener('dragleave', ['$event']) onDragLeave(event: Event) {
    event.preventDefault()
    event.stopPropagation()
    this.isDraggingOver = false
  }

  // Listen for the drop event
  @HostListener('drop', ['$event']) onDrop(event: DragEvent) {
    event.preventDefault()
    event.stopPropagation()

    // Emit the custom output event with the dropped files
    if (event.dataTransfer.files.length > 0) {
      this.fileDropped.emit(event.dataTransfer.files)
    }

    // Reset the dragging over class
    this.isDraggingOver = false
  }
}
